var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "51px",
    height: "51px",
    viewBox: "0 0 51 51",
    enableBackground: "new 0 0 51 51",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#575757",
    d: "M42.623,24.197l-15.834-0.001L26.785,8.365c0-0.319-0.141-0.646-0.389-0.894 c-0.479-0.478-1.348-0.477-1.812-0.015c-0.243,0.243-0.378,0.565-0.378,0.908v15.828H8.383c-0.709,0.002-1.287,0.58-1.285,1.288 c0,0.688,0.6,1.292,1.285,1.292l15.828,0.002L24.213,42.6c-0.002,0.32,0.14,0.646,0.387,0.896c0.25,0.251,0.578,0.396,0.9,0.396 h0.002c0.707,0,1.283-0.58,1.285-1.291l-0.002-15.824h15.83c0.344,0,0.666-0.135,0.908-0.377c0.244-0.244,0.379-0.567,0.379-0.914 C43.9,24.822,43.279,24.197,42.623,24.197z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.7176f3c8042092ed7658e9d6b97bfa3c.svg";
export { ForwardRef as ReactComponent };